import React, { useState } from "react";
import CommonModal from "../../Settings/components/ResetContext/components/DumpModal";
import { Button } from "@mui/material";
import axios from "axios";
import env from "../../../config/env";
import { useUserInfo } from "../../../context/user";
import { useUsersContext } from "../../../context/usersContext";

const RenameChatModal = ({ isOpen, onClose, chatTitle, id }) => {
  const [input, setInput] = useState(chatTitle || "");
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState();
  const [userInfo, , , , userActiveLocation] = useUserInfo();
  const BASE_URL = `${env.API_URL}/v1`;
  const {
    fetchChats
  } = useUsersContext();

  const handleCategorySubmit = async () => {
    setProcessing(true);
    setError(false);

    if (input === "" || input === undefined) {
      setError(true);
      setProcessing(false);
      return false;
    }

    const response = await axios.post(`${BASE_URL}/chat/updateChatname`, {
      conversation_id: id,
      name: input,
      userId: userInfo?._id,
      locationId: userActiveLocation?.id,
      type: "user",
    });
    fetchChats()
    setProcessing(false);
    if (response) {
      onClose();
      setInput("");
    }
  };

  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <p className="text-[14px] font-[600] truncate">{`Rename '${chatTitle || "hi"}'`}</p>
      }
      showAlert={false}
    >
      <input
        type="text"
        onChange={(e) => setInput(e.target.value)}
        value={input}
        className="!outline-0 border !border-[#d9d9d9]"
      />
      {error && <small style={{ color: "red" }}>name required!</small>}
      <Button
        className="!text-[14px] !font-[600] !mt-4 !bg-black !text-white w-full flex items-center gap-3 justify-center"
        disabled={processing}
        onClick={handleCategorySubmit}
      >
        {processing && <div className="spinner"></div>} <span>Update</span>
      </Button>
    </CommonModal>
  );
};

export default RenameChatModal;
